module.exports = __webpack_public_path__ + "img/1557614087864655874.2f1024bf.png";